var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('fieldset', {
    staticClass: "debt-plan",
    attrs: {
      "disabled": _vm.busy
    }
  }, [_c('legend', [_vm._v("Čo sa stane s úverom?")]), _c('div', {
    staticClass: "debt-plan-options",
    attrs: {
      "role": "group",
      "aria-label": "Plán existujúceho úveru"
    }
  }, _vm._l(_vm.options, function (option) {
    return _c('button', {
      key: option.value,
      staticClass: "debt-plan-option",
      "class": {
        active: _vm.value === option.value
      },
      attrs: {
        "type": "button",
        "aria-pressed": _vm.value === option.value ? 'true' : 'false',
        "title": option.note,
        "disabled": _vm.busy
      },
      on: {
        "click": function click($event) {
          return _vm.$emit('change', option.value);
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": option.icon,
        "size": 16
      }
    }), _c('span', [_vm._v(_vm._s(option.label))])], 1);
  }), 0), _c('div', {
    staticClass: "debt-plan-note",
    attrs: {
      "aria-live": "polite"
    }
  }, [_vm._v(" " + _vm._s(_vm.busy ? "Ukladám zmenu…" : _vm.selectedNote) + " ")])]);

}
var staticRenderFns = []

export { render, staticRenderFns }